module.exports = __webpack_public_path__ + "img/favorite.d26241b2.svg";